import { ArrowDown, MapPin, Star } from "lucide-react";
import useSiteSettings from "@/hooks/useSiteSettings";

const HERO_IMG = "/hero-gwagon-soap.png";

export default function Hero() {
  const { settings } = useSiteSettings();
  const h = settings.hero;

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative py-16 lg:py-24 px-6 lg:px-12 overflow-hidden bg-[#FDF9F3]"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 od-reveal">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 bg-[#F5EBD9] rounded-full">
            <MapPin className="w-3.5 h-3.5 text-[#A67F4E]" strokeWidth={2} />
            <span className="text-xs font-semibold text-[#3D2E1C]">
              {h.location_label}
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02] text-[#3D2E1C]"
          >
            {h.headline_line1}{" "}
            <span className="font-hand text-[#A67F4E] text-5xl sm:text-6xl lg:text-7xl italic">
              {h.headline_line2}
            </span>
          </h1>

          <p className="mt-6 text-lg text-[#3D2E1C]/70 max-w-xl font-medium leading-relaxed">
            {h.subtitle}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#booking"
              data-testid="hero-book-button"
              className="group inline-flex items-center gap-2 px-6 py-3.5 bg-[#3D2E1C] text-[#FDF9F3] hover:bg-[#A67F4E] transition-all duration-300 text-sm font-bold rounded-full"
            >
              Book Appointment
              <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" />
            </a>
            <a
              href="#packages"
              data-testid="hero-packages-button"
              className="inline-flex items-center px-6 py-3.5 border-2 border-[#3D2E1C] text-[#3D2E1C] hover:bg-[#3D2E1C] hover:text-[#FDF9F3] transition-all duration-300 text-sm font-bold rounded-full"
            >
              View Packages
            </a>
          </div>

          <div className="mt-8 flex items-center gap-4 text-sm text-[#7A6A55]">
            <div className="flex items-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} className="w-4 h-4 fill-[#D6B98D] text-[#D6B98D]" strokeWidth={0} />
              ))}
            </div>
            <span className="font-medium">{h.tagline_footer}</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative">
            <div className="absolute -inset-2 bg-[#D6B98D] rounded-3xl -rotate-3" />
            <div className="relative rounded-3xl overflow-hidden bg-white shadow-xl">
              <img
                src={HERO_IMG}
                alt="Overdrive Auto Spa detailing"
                className="w-full h-[500px] object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-[#3D2E1C] text-[#FDF9F3] px-5 py-3 rounded-2xl rotate-3 shadow-lg">
              <div className="font-hand text-xl text-[#D6B98D]">real teens</div>
              <div className="font-hand text-xl text-[#D6B98D]">real detail</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
